import Typography from '@mui/material/Typography';
// eslint-disable-next-line no-duplicate-imports
import type { TypographyProps } from '@mui/material/Typography';
import React from 'react';

export const Heading1: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='h1' />
);

export const Heading2: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='h2' />
);

export const Heading5: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='h5' />
);

export const Heading6: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='h6' />
);

export const Subtitle1: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='subtitle1' />
);

export const Subtitle2: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='subtitle2' />
);

export const Paragraph1: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='body1' />
);

export const Paragraph2: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='body2' component='span' />
);

export const Caption1: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='caption1' />
);

export const Caption2: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='caption2' />
);

export const ButtonText: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='button' />
);

export const LinkText: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='linkText' />
);

export const InputText: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='inputText' />
);

export const Body1: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='body1' />
);

export const Body2: React.FC<TypographyProps> = (props): React.ReactElement => (
    <Typography {...props} variant='body2' />
);
